import MailchimpSubscribe from "react-mailchimp-subscribe";
import { Newsletter } from "../components/Newsletter";

export const MailchimpForm = () => {
  const postUrl = "https://gmail.us9.list-manage.com/subscribe/post?u=f6a65e64215a5f63eb4bc8508&id=1ccbba7620";

  return (
    <>
      <MailchimpSubscribe
        url={postUrl}
        render={({ subscribe, status, message }) => (
          <Newsletter
            status={status}
            message={message}
            onValidated={formData => subscribe(formData)}
            />
        )}
        />
    </>
  )
}
